import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/shop/Navbar";
import Hero from "@/components/shop/Hero";
import MarqueeRibbon from "@/components/shop/MarqueeRibbon";
import Catalog from "@/components/shop/Catalog";
import Footer from "@/components/shop/Footer";
import WhatsAppFloat from "@/components/shop/WhatsAppFloat";
import { PrivacyPolicy, TerminiCondizioni, CookiePolicy } from "@/pages/Legal";
import CookieBanner from "@/components/shop/CookieBanner";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <MarqueeRibbon />
      <Catalog />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[#050505] font-sans text-[#fafafa] antialiased">
        <div className="noise-overlay" aria-hidden />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/termini-e-condizioni" element={<TerminiCondizioni />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
        <WhatsAppFloat />
        <CookieBanner />
      </div>
    </BrowserRouter>
  );
}

export default App;
